/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const FeetStop = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M54.232 105.232c10.9-2.726 7.806-16.298 4.273-26.578-.076-.297-.162-.574-.577-.418-4.594 3.09-13.774 5.86-20.348 4.787 1.006 13.518 5.162 25.087 16.652 22.209z" />
    <path d="M57.348 76.547c-5.296 3.012-12.522 4.975-19.344 4.626-2.6-11.05-8.044-20.23-8.002-29.687.022-4.22.127-8.355 1.093-13.376 1.216-6.312 3.453-15.978 10.186-17.882 9.3-2.625 13.714 8.165 16.048 14.693 1.22 3.4 2.327 7.09 2.475 9.756.71 12.502-7.326 18.848-2.456 31.87z" />
    <g>
      <path d="M75.984 104.673c-10.032-3.233-6.561-16.646-2.825-26.75.085-.292.177-.565.556-.389 4.143 3.301 12.572 6.5 18.74 5.737-1.523 13.456-5.896 24.817-16.471 21.402z" />
      <path d="M74.33 75.873c4.8 3.256 11.443 5.557 17.812 5.529 2.902-10.918 8.37-19.833 8.742-29.28.163-4.217.245-8.354-.436-13.415-.858-6.363-2.52-16.123-8.708-18.341-8.547-3.06-13.126 7.513-15.582 13.924-1.285 3.341-2.476 6.973-2.73 9.63-1.205 12.458 6.002 19.173.902 31.953z" />
    </g>
  </svg>
);

export default extendIcon(FeetStop);
